import { Children, cloneElement, type PropsWithChildren, type ReactElement } from 'react';

import { type BookmakersConfig } from '@cx-modules/types';

import { GridTable, TableGroup } from '~/apps/product-plus/components/cxy/cxy.ts';
import { type BetInsightsConfig } from '~/apps/product-plus/configuration/BetInsightsConfiguration';
import {
  type BettingInsightsContent,
  type BettingSplitsIndex,
  type BettingSplitsResult,
  type EsIndex } from
'~/apps/product-plus/configuration/types';
import { type BettingInsightsUI } from '~/apps/product-plus/configuration/ui/BettingInsightsUI';

import { EventDetails } from '../EventDetails';
import { type SectionProps } from '../ResultTable';

import styles from './styles/BettingSplits.module.css';

function BettingSplitsComponent({
  children,
  config,
  content,
  result,
  showLabel = true





}: {config: BetInsightsConfig<BettingSplitsIndex, BettingInsightsContent<BettingSplitsIndex>>;content: BettingInsightsContent<BettingSplitsIndex>[];result: BettingSplitsResult;showLabel?: boolean;} & PropsWithChildren) {
  const label = showLabel ?
  <EventDetails<BettingSplitsIndex> content={content} renderTitle={config.ui.card.title.render} result={result} /> :
  undefined;

  return (
    <TableGroup label={label}>
      <>
        {Children.map(children, (child, index) =>
        <GridTable
          className={styles.bettingSplits}
          key={`${result.subeventName}-${result.eventDisplayName}-${result.subeventStartTime}-pbd-table-${index}`}
          label={result.subeventName}
          mobileColumns={3}>

            {cloneElement(child as ReactElement)}
          </GridTable>
        )}
      </>
    </TableGroup>);

}

function BettingSplitsBody<TIndex extends EsIndex, TContent extends BettingInsightsContent<TIndex>>({
  bookmakers,
  cells,
  content,
  isFootball,
  resultIndex,
  sectionProps







}: {bookmakers: BookmakersConfig;cells: BettingInsightsUI<TIndex, TContent>['card']['table']['cells'];content: TContent;isFootball?: boolean;resultIndex: number;sectionProps: SectionProps;} & PropsWithChildren) {
  const Comparison = () =>
  <GridTable.Cell
    isFullWidthMobile={cells[1].isFullWidthMobile}
    isMain={cells[1].isMain}
    justifyContent={cells[1].justifyContent}
    order={cells[1].order}>

      {cells[1].render({
      content,
      bookmakers,
      resultIndex
    })}
    </GridTable.Cell>;


  const LeftBet = () =>
  <GridTable.Cell justifyContent={cells[0].justifyContent} start={cells[0].start}>
      {cells[0].render({
      content,
      bookmakers,
      resultIndex
    })}
    </GridTable.Cell>;

  const CenterBet = () =>
  <GridTable.Cell justifyContent={cells[3].justifyContent} start={cells[3].start}>
      {cells[3].render({
      content,
      bookmakers,
      resultIndex
    })}
    </GridTable.Cell>;

  const RightBet = () =>
  <GridTable.Cell justifyContent={cells[2].justifyContent} start={cells[2].start}>
      {cells[2].render({
      content,
      bookmakers,
      resultIndex
    })}
    </GridTable.Cell>;


  const GridRow = () =>
  isFootball ?
  <GridTable.Row className={styles.soccerRow}>
        <Comparison />
        <LeftBet />
        <CenterBet />
        <RightBet />
      </GridTable.Row> :

  <GridTable.Row>
        <LeftBet />
        <Comparison />
        <RightBet />
      </GridTable.Row>;


  return (
    <GridTable.Body {...sectionProps} role="rowgroup">
      <GridRow />
    </GridTable.Body>);

}

BettingSplitsComponent.Body = BettingSplitsBody;

export { BettingSplitsComponent as BettingSplits };